// Mock data for John Herbert Limited recruitment website

export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_2bcc1db3-b04f-47fb-9033-87bf0b3f7bc3/artifacts/nzu5bshy_%40jh-logo-white.png';

export const LOGO_MARK =
  'https://customer-assets.emergentagent.com/job_2bcc1db3-b04f-47fb-9033-87bf0b3f7bc3/artifacts/jhmark.png';

export const LICENCE_PDF_1 =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_2bcc1db3-b04f-47fb-9033-87bf0b3f7bc3/artifacts/46c50tq9_LICENCE%20TO%20OPERATE%20PRIVATE%20EMPLOYMENT%20AGENCY%20JOHN%20HERBERT%20LTD..pdf';
export const LICENCE_PDF_2 =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_2bcc1db3-b04f-47fb-9033-87bf0b3f7bc3/artifacts/tz21yk5t_LICENCE%20TO%20OPERATE%20PRIVATE%20EMPLOYMENT%20AGENCY%20JOHN%20HERBERT%20LIMITED%20doc%201.pdf';

export const heroSlides = [
  {
    id: 1,
    eyebrow: 'GOVERNMENT OF GHANA LICENSED — PEA/819',
    title: 'Ghana\u2019s Work Abroad',
    titleAccent: 'Programme Partner',
    cta: 'Partner With Us',
    image:
      'https://customer-assets-jt897jd0.emergentagent.net/job_jh-intl-recruitment/artifacts/sqk5jkk0_adobestock_496048536-1200x805.jpeg',
  },
  {
    id: 2,
    eyebrow: 'ETHICAL INTERNATIONAL RECRUITMENT FROM GHANA',
    title: 'Your Future Without Borders;',
    titleAccent: 'Ghanaian Talent for the World',
    cta: 'Hire Ghanaian Talent',
    image:
      'https://customer-assets-jt897jd0.emergentagent.net/job_jh-intl-recruitment/artifacts/w3ia92h0_Shutterstock_2311883543.jpg',
  },
];

export const services = [
  {
    icon: 'UserSearch',
    title: 'Talent Sourcing',
    desc: 'Identifying and recruiting suitably qualified Ghanaian professionals and skilled workers matched to your workforce requirements.',
  },
  {
    icon: 'ClipboardCheck',
    title: 'Screening & Shortlisting',
    desc: 'Rigorous screening, structured interviews and competency assessments so only the most suitable candidates reach you.',
  },
  {
    icon: 'ShieldCheck',
    title: 'Verification & Due Diligence',
    desc: 'Thorough verification of academic qualifications, professional certifications, employment history and references.',
  },
  {
    icon: 'CalendarClock',
    title: 'Interview Coordination',
    desc: 'End-to-end management of scheduling, communication, documentation and coordination between employers and applicants.',
  },
  {
    icon: 'FileBadge',
    title: 'Documentation & Compliance',
    desc: 'Full compliance with the laws of Ghana and the destination country following internationally recognised ethical standards.',
  },
  {
    icon: 'Plane',
    title: 'Pre-Departure Orientation',
    desc: 'Workplace expectations, cultural awareness, professional conduct and settlement preparation for a smooth transition.',
  },
  {
    icon: 'GraduationCap',
    title: 'Workforce Readiness Training',
    desc: 'Programmes that enhance professional skills, communication, customer service and health and safety awareness.',
  },
  {
    icon: 'Handshake',
    title: 'Employer Partnerships',
    desc: 'Tailored, government-compliant recruitment partnerships built on transparency and long-term value.',
  },
];

export const industries = [
  { name: 'Healthcare', icon: 'Stethoscope' },
  { name: 'Aged Care', icon: 'HeartHandshake' },
  { name: 'Hospitality', icon: 'ConciergeBell' },
  { name: 'Construction', icon: 'HardHat' },
  { name: 'Engineering', icon: 'Cog' },
  { name: 'Manufacturing', icon: 'Factory' },
  { name: 'Agriculture', icon: 'Sprout' },
  { name: 'Mining', icon: 'Pickaxe' },
  { name: 'Logistics & Supply Chain', icon: 'Truck' },
  { name: 'Information Technology', icon: 'Cpu' },
  { name: 'Administration & Office Support', icon: 'Briefcase' },
  { name: 'Skilled Trades', icon: 'Wrench' },
  { name: 'Domestic & Community Support', icon: 'Home' },
];

export const healthcareRoles = [
  'Registered Nurses',
  'Licensed Practical Nurses',
  'Caregivers',
  'Personal Support Workers',
  'Healthcare Assistants',
  'Occupational Therapists',
  'Housekeepers',
  'Kitchen Assistants',
  'Disability Support Workers',
  'Community Care Workers',
];

export const whyChooseUs = [
  'Government of Ghana Licensed Private Employment Agency',
  'Fully compliant with the Labour Act, 2003 (Act 651)',
  'Ethical and transparent recruitment practices',
  'Comprehensive candidate screening and verification',
  'End-to-end recruitment and deployment support',
  'Strong network of qualified Ghanaian professionals',
  'Efficient documentation and compliance management',
  'Tailored recruitment solutions for employers worldwide',
  'Ongoing commitment to quality and long-term partnerships',
];

export const faqs = [
  {
    q: 'Is John Herbert Limited a licensed recruitment agency?',
    a: 'Yes. John Herbert Limited is a Government of Ghana-licensed Private Employment Agency (Licence No. PEA/819), authorised under the Labour Act, 2003 (Act 651). You can view and download our official licence documents in the Licences section of this website.',
  },
  {
    q: 'Which industries and roles do you recruit for?',
    a: 'We recruit across Healthcare, Aged Care, Hospitality, Construction, Engineering, Manufacturing, Agriculture, Mining, Logistics, IT, Administration, Skilled Trades and Domestic & Community Support Services. We have particular expertise in healthcare and aged care roles.',
  },
  {
    q: 'How does the recruitment and deployment process work?',
    a: 'We handle end-to-end recruitment: talent sourcing, screening, verification, interview coordination, documentation, compliance, pre-departure orientation and workforce readiness training \u2014 all in line with Ghana\u2019s Work Abroad Programme and destination country regulations.',
  },
  {
    q: 'Do you charge job seekers?',
    a: 'We adhere strictly to ethical recruitment principles and applicable laws of Ghana. All fees, where applicable, are lawful, transparent and communicated in writing before any commitment is made.',
  },
  {
    q: 'How can employers partner with John Herbert Limited?',
    a: 'Employers can reach out via the contact form on this website or by email. We\u2019ll set up an initial consultation to understand your workforce needs and design a compliant recruitment plan.',
  },
];

export const stats = [
  { label: 'Compliance Standard', value: '100%' },
  { label: 'Industries Served', value: '13+' },
  { label: 'Talent Pipeline Depth', value: 'Deep' },
];

export const contact = {
  address: '1B Sixth Circular Road, Cantonments / Accra-Ghana',
  email: 'hello@johnherbertltd.com',
  phone: '+233 (0) 000 000 000',
  licenceNo: 'PEA/819',
};

export const brandStrip = [
  'Labour Act 2003',
  'Ghana Work Abroad Programme',
  'PEA/819 Licensed',
  'Ethical Recruitment',
  'Ministry of Employment',
  'Ghana Immigration Service',
];
